module.exports = __webpack_public_path__ + "static/media/Globant.d7fdc195.png";